import applyListingVariations from './Listing';
import applyTeaserVariations from './Teaser';

export default function applyConfig(config) {
  applyListingVariations(config);
  applyTeaserVariations(config);
}
